const KEY = `${process.env.NEXT_PUBLIC_CLIENT}-${process.env.NEXT_PUBLIC_ENVIRONMENT}-PUBLIC:state`;

export class StateLoader {

  loadState<T = Record<string, unknown>>(): T {
    try {
      let serializedState = localStorage.getItem(KEY);
      if (serializedState === null) {
        return this.initializeState() as T;
      }
      return JSON.parse(serializedState);
    } catch (err) {
      return this.initializeState() as T;
    }
  }

  saveState(state: unknown): void {
    try {
      let serializedState = JSON.stringify(state);
      localStorage.setItem(KEY, serializedState);
    } catch (err) {}
  }

  initializeState(): Record<string, unknown> {
    return {
      //state object
    };
  }

}
